import React from 'react';

/**
 * Definições das colunas para a tabela de Frequência.
 */
export const getAttendanceColumns = () => [
    {
        label: "Data",
        key: "date",
        render: (row) => {
            if (!row.date) return "-";
            const parts = row.date.split("-");
            return (
                <div className="fw-medium">
                    {`${parts[2]}/${parts[1]}/${parts[0]}`}
                    {row.time && <span className="text-muted ms-1 font-size-12">{row.time}</span>}
                </div>
            );
        }
    },
    {
        label: "Atividade",
        key: "activityName",
        render: (row) => row.activityName || "Aula"
    },
    {
        label: "Professor",
        key: "employeeName",
        render: (row) => row.employeeName || "-"
    },
    {
        label: "Status",
        key: "status",
        render: (row) => {
            const isAttended = row.status === "ATTENDED";
            return (
                <span className={`badge rounded-0 ${isAttended ? 'bg-success-subtle text-success' : 'bg-danger-subtle text-danger'} px-2 py-1`}>
                    {isAttended ? "Presente" : "Falta"}
                </span>
            );
        }
    }
];
